import { cx } from '@linaria/core';
import { AlertIcon } from '@ui/kit/icons';
import { errorCls, iconCls, textCls, buttonCls, buttonTextCls, loadingEllipsisCls } from './styles.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ErrorMessage({
  isLoading,
  onRetry,
  ref
}) {
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: errorCls,
    children: [/*#__PURE__*/jsx("div", {
      className: iconCls,
      children: /*#__PURE__*/jsx(AlertIcon, {
        width: 150,
        height: 150
      })
    }), /*#__PURE__*/jsx("p", {
      className: textCls,
      children: "Noget gik galt!"
    }), /*#__PURE__*/jsxs("button", {
      className: buttonCls,
      onClick: onRetry,
      children: [/*#__PURE__*/jsx("span", {
        className: buttonTextCls,
        children: "Klik her for at pr\xF8ve igen"
      }), /*#__PURE__*/jsx("span", {
        className: cx(loadingEllipsisCls, isLoading && "active"),
        children: "."
      })]
    })]
  });
}

export { ErrorMessage };
//# sourceMappingURL=Error.js.map
